export default __webpack_public_path__ + "static/saisie-ced6d613f85bcbc31e669ee328df7057.jpg";